<template>
  <v-autocomplete
    :items="cidades"
    :loading="loading"
    :search-input.sync="search"
    item-text="nome"
    item-value="id"
    label="Cidades"
    hide-no-data
    hide-selected
    v-model="model"
    @change="selecionarCidade"
  />
</template>

<script>
import api from '../../api'

export default {
  name: 'FiltroCidade',
  props: {
    estado: {
      required: true
    }
  },
  data() {
    const cidadesInitial = [
      {
        id: null,
        nome: 'Todas as cidades'
      }
    ]
    return {
      cidadesInitial,
      model: null,
      cidades: cidadesInitial,
      loading: false,
      buscador: null,
      search: null,
      selected: false
    }
  },
  watch: {
    estado() {
      this.cidades = this.cidadesInitial
    },
    search() {
      if (this.search === 'Todas as cidades') {
        return
      }
      if (this.selected) {
        this.selected = false
        return
      }
      if (this.buscador !== null) {
        clearTimeout(this.buscador)
      }
      this.buscador = setTimeout(this.buscarCidades, 1000)
    },
  },
  methods: {
    async buscarCidades() {
      let cidades
      try {
        this.loading = true
        this.cidades = this.cidadesInitial
        const response = await api.post('/', {
          query: `{ cidades(estado: "${this.estado}", nome: "${this.search}") { id nome } }`
        })
        cidades = response.data.data.cidades
      }
      catch (e) {
        cidades = []
      }
      finally {
        this.cidades = this.cidades.concat(cidades)
        this.loading = false
      }
    },
    selecionarCidade(value) {
      this.$emit('cidade-selecionada', value)
      this.selected = true
    }
  }
}
</script>
